import { Text } from "@chakra-ui/react";

export const formatCapDescription = (description: string) => {
  const regex = /(\*)(.*)(\.\.\.)+/g;

  return description
    .split(regex)
    .map((field: string, idx: number) => (idx % 2 ? null : field))
    .join("...")
    .split("...")
    .map((token: string, idx: number) => {
      return token.toUpperCase() === token ? (
        <Text key={idx} apply="styles.mdx.h3">
          {token}
        </Text>
      ) : (
        <Text key={idx} color="black" fontWeight="medium" fontSize="lg">
          {token}
        </Text>
      );
    });
};
